export default "assets/images/icons/cles-df13e84b.svg";